<template>
  <div>
    <div v-if="isAcquire" class="cashOfferCard card py-3 px-4 text-center mb-4">
      {{ $t('message.acquire.personalInfoFormPrompt') }}
    </div>
    <PersonalInfoForm
      :buttonLabelKey="buttonLabelKey"
      @FormIsValid="continueForm"
      :av-errors="avErrors"
      ref="personalInfoForm"
    ></PersonalInfoForm>
  </div>
</template>

<script>
import { avErrorMixin, tradePersonalInfoMixin } from '@/mixins';
import { AVRProducts } from '@/utils/enums';
import PersonalInfoForm from '../../components/trade-in/PersonalInfoForm.vue';

export default {
  data() {
    return {};
  },
  mixins: [avErrorMixin, tradePersonalInfoMixin],
  components: { PersonalInfoForm },
  computed: {
    buttonLabelKey() {
      if (this.tradeAcquireAdditionalVehicleDetails) {
        return 'common.continue';
      }
      if (this.getCurrentProduct === AVRProducts.ACQUIRE) {
        return this.getPhoneNumberVerificationArray.acquire
          ? 'common.continue'
          : 'acquire.buttonLabel.seeEstimatedVehicleValue';
      }
      return this.getPhoneNumberVerificationArray.trade ? 'common.continue' : 'trade.buttonLabel.seeTradeValue';
    },
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      await this.processPersonalInfo();
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.cashOfferCard {
  background: $primary-light-background2;
  border-color: $primary-light-background2;
  color: rgb(0, 64, 133);
}
</style>
